module.exports = __webpack_public_path__ + "assets/a956d4db9824ade03fe5866d1eba2338.png";